import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchArticleById } from "../api/articleApi";

// Async thunk to fetch a single article by ID
export const getArticle = createAsyncThunk(
  "article/getArticle",
  async (articleId, { rejectWithValue }) => {
    try {
      const data = await fetchArticleById(articleId);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch article",
      );
    }
  },
);

const articleSlice = createSlice({
  name: "article",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearArticle: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArticle.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArticle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearArticle } = articleSlice.actions;
export default articleSlice.reducer;
